import { useStyles } from './useStyles';

const styles = theme => ({
  isComplete: {
    '& .MuiInput-underline:after, .MuiFilledInput-underline:after': {
      transform: 'scaleX(1)',
    },
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline:hover': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      }
    }
  }
})

export const useIsCompleteInputClass = (value, error, touched) => {
  const classes = useStyles(styles);
  const isComplete = value !== '' && !error && touched;

  return [isComplete, classes.isComplete];
}